import { Form, Formik } from "formik";
import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import * as Yup from "yup";
// images

import { Col, Container, Row } from "react-bootstrap";
import camera from "../../../assets/images/icons/camera.svg";
import { uploadProfilePictureAction } from "../actions";
import ThumbImg from "./uploadImg";
import SubmitLoader from "../../../components/SubmitLoader";
import CustomButton from "../../../components/Buttons/CustomButton";

const validationSchema = Yup.object({
  photo: Yup.string().required("Profile image cannot be empty"),
});

function ProfilePhoto(props) {
  const { activeStep, nextStep, previousStep, currentStep, getActiveStep, totalSteps } = props;
  const [setImage] = useState("");
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const initialState = {
    photo: "",
  };

  const handlePrevStep = () => {
    activeStep(currentStep - 1);
    previousStep();
  };

  const handleSubmit = (values) => {
    setLoader(true);
    dispatch(uploadProfilePictureAction(values, props, setLoader));
  };

  const handleNextStep = () => {
    setTimeout(() => {
      activeStep(currentStep + 1);
      nextStep();
    }, 500);
  };

  return (
    <div>
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md={10} lg={8} xl={6}>
            <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema}>
              {({ touched, errors, setFieldValue, values }) => {
                return (
                  <Form className="loginForm">
                    <h1 className="text-white text-center">Add A Profile Photo</h1>
                    <div className="uploadProfilePhoto">
                      <ThumbImg file={values.photo} setImage={setImage} className={values.photo ? "uploadthumbImg" : "removeImage"} />
                      <div className={values.photo ? "uploadImageBtn imageRemove" : "uploadImageBtn"}>
                        <span>Click to Upload</span>
                        <label htmlFor="photo" className="inputFile">
                          <img src={camera} alt="imagesss" />
                          <input
                            id="photo"
                            name="photo"
                            type="file"
                            onChange={(event) => {
                              setFieldValue("photo", event.currentTarget.files[0]);
                            }}
                          />
                        </label>
                      </div>
                      {touched.photo && errors.photo && <p className="errorMsg">{errors.photo}</p>}
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-5">
                      <CustomButton type="button" variant="purple" gradient onClick={handlePrevStep}>
                        Previous
                      </CustomButton>
                      <span />
                      <button type="submit" className="nextBtn nextPrevBtn" disabled={loader}>
                        {loader ? (
                          <>
                            Sending... <SubmitLoader />
                          </>
                        ) : (
                          <CustomButton type="button" variant="purple" gradient>
                            Next
                          </CustomButton>
                        )}
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Col>
        </Row>
      </Container>

      <p className="px-4 text-white text-xl d-flex justify-content-between fw-bold mt-5">
        <span>
          Step {currentStep + 1} of {totalSteps + 1}
        </span>
        <CustomButton type="button" variant="purple" gradient aria-hidden onClick={handleNextStep} className="cursor-pointer">
          Skip For Now
        </CustomButton>
      </p>
      <div style={{ width: getActiveStep === 3 ? "80%" : "60%" }} className="signupProgressBar" />
    </div>
  );
}

export default connect(null, { uploadProfilePictureAction })(ProfilePhoto);
